import {useMemo} from 'react';
import {assert} from 'assert-ts';
import type {ManifestationStatus} from 'api/types';
import {useAppSelector} from 'store/hooks';
import {
  selectMetadataEditEditStatuses,
  selectMetadataEditStatuses,
} from '../metadataEditSlice';

export const useStatusAndShowError = (
  id: string,
): {
  activeStatus: ManifestationStatus;
  status: ManifestationStatus;
  changedStatus?: ManifestationStatus;
  showError: boolean;
} => {
  const status = useAppSelector(selectMetadataEditStatuses)[id];
  const editStatus = useAppSelector(selectMetadataEditEditStatuses)[id];

  const result = useMemo(() => {
    const s = assert(status, 'useStatusAndShowError: no status');
    return {
      activeStatus: s.previewStatus ?? s.changedStatus ?? s.status,
      status: s.status,
      changedStatus: s.changedStatus,
      showError: !!(
        s.previewStatus ||
        s.changedStatus ||
        (editStatus?.isSaving ?? false)
      ),
    };
  }, [editStatus, status]);

  // useLogValue(`status.${id.substring(0, 5)}`, status);
  // useLogValue(`result.${id.substring(0, 5)}`, result);
  return result;
};
